import React, { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const STATUSES = ["", "Unpaid", "Deposit Paid", "Partially Paid", "Paid in Full", "No Payment Required", "Awaiting Payment (In Clinic)"];
const inputCls = "border hairline p-2 text-sm w-full";

export function BookingPaymentEditor({ booking, onSaved }) {
  const [open, setOpen] = useState(false);
  const [price, setPrice] = useState(String(booking.subtotal ?? ""));
  const [paid, setPaid] = useState(String(booking.amount_paid ?? 0));
  const [method, setMethod] = useState(booking.payment_method || "");
  const [status, setStatus] = useState("");
  const [busy, setBusy] = useState(false);

  const save = async () => {
    setBusy(true);
    try {
      const body = { amount_paid: Number(paid || 0) };
      if (price !== "" && Number(price) !== Number(booking.subtotal)) body.price = Number(price);
      if (method) body.payment_method = method;
      if (status) body.payment_status = status;
      const r = await api.patch(`/admin/bookings/${booking.id}/payment`, body);
      toast.success("Payment details updated");
      setOpen(false);
      onSaved && onSaved(r.data);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not update payment");
    }
    setBusy(false);
  };

  const resend = async () => {
    try {
      await api.post(`/admin/bookings/${booking.id}/resend-confirmation`);
      toast.success("Confirmation email sent");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not send confirmation");
    }
  };

  return (
    <div className="mt-6 border-t hairline pt-4" data-testid="payment-editor">
      <div className="flex items-center justify-between gap-2 flex-wrap">
        <p className="mono-label">Price &amp; Payment</p>
        <div className="flex gap-2">
          <button data-testid="resend-confirmation-btn" onClick={resend} className="mono-label border hairline px-3 py-2 hover:bg-alt text-[10px]">Send Confirmation</button>
          <button data-testid="edit-payment-toggle" onClick={() => setOpen(!open)} className="mono-label border hairline px-3 py-2 hover:bg-alt text-[10px]">{open ? "Close" : "Edit Price / Payment"}</button>
        </div>
      </div>
      {open && (
        <div className="mt-3 grid grid-cols-2 gap-3">
          <label className="block"><span className="mono-label text-[10px] text-stone-500 block mb-1">BOOKING PRICE (£)</span>
            <input data-testid="edit-price" type="number" min="0" step="0.01" value={price} onChange={(e) => setPrice(e.target.value)} className={inputCls} /></label>
          <label className="block"><span className="mono-label text-[10px] text-stone-500 block mb-1">AMOUNT PAID (£)</span>
            <input data-testid="edit-amount-paid" type="number" min="0" step="0.01" value={paid} onChange={(e) => setPaid(e.target.value)} className={inputCls} /></label>
          <label className="block"><span className="mono-label text-[10px] text-stone-500 block mb-1">METHOD</span>
            <select data-testid="edit-payment-method" value={method} onChange={(e) => setMethod(e.target.value)} className={inputCls}>
              <option value="">—</option><option value="cash">Cash</option><option value="card">Card</option>
            </select></label>
          <label className="block"><span className="mono-label text-[10px] text-stone-500 block mb-1">STATUS</span>
            <select data-testid="edit-payment-status" value={status} onChange={(e) => setStatus(e.target.value)} className={inputCls}>
              {STATUSES.map((s) => <option key={s} value={s}>{s || "Auto (from amount paid)"}</option>)}
            </select></label>
          <p className="col-span-2 text-[11px] text-stone-500">Price change applies to this booking only. Treatment and Model Day prices stay the same.</p>
          <div className="col-span-2 flex justify-end">
            <button data-testid="save-payment-btn" onClick={save} disabled={busy} className="bg-stone-900 text-white px-4 py-2 mono-label disabled:opacity-50" style={{ color: "#fff" }}>{busy ? "Saving…" : "Save"}</button>
          </div>
        </div>
      )}
    </div>
  );
}
